import { Group } from 'three'
import { useNodeNeighborBaseFloorElevationReactiveMap } from '../../../rx/memo/useNodeNeighborBaseFloorElevationReactiveMap'
import type { Engine } from '../../core/engine/Engine.type'
import type { EntityGraphNode } from '../../core/engine/EntityGraphNode/EntityGraphNode.type'
import type { JungleEntity } from '../../core/entity/EntityType/Jungle'
import createJungleTerrainClusterGroup from '../objects/Trees/Jungle/createJungleTerrainClusterGroup'

export default function createJungleGroup(
  engine: Engine,
  ent: EntityGraphNode<JungleEntity>,
  callback: (group: Group) => void
): void {
  const neighborBaseElevationReactiveMap = useNodeNeighborBaseFloorElevationReactiveMap(engine)
  createJungleTerrainClusterGroup([ent], neighborBaseElevationReactiveMap).then(callback)
}
